/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import MLIcon from '../MLIcon';

import s from './StatusIndicator.module.css';

const StatusIndicator = ({
  isReefLinked,
  isStudent,
  isReefStatusFetching,
  onClickButton,
  hasInstructorLinkedCourse,
}) => {
  const isStudentLinked = isReefLinked;

  if (
    !isStudentLinked &&
    hasInstructorLinkedCourse &&
    isStudent &&
    !isReefStatusFetching
  ) {
    return (
      <div className={s.statusBar}>
        <div className={s.content}>
          <MLIcon className={s.icon} type="alert_outline" role="presentation" />
          iClicker needs to be connected.
          <button onClick={onClickButton}>
            Click here to connect iClicker
          </button>
        </div>
      </div>
    );
  }

  return null;
};

StatusIndicator.propTypes = {
  gracePeriodExpiresIn: PropTypes.number,
  groupsetChanges: PropTypes.array,
  isReefLinked: PropTypes.bool,
  isStudent: PropTypes.bool,
  isReefStatusFetching: PropTypes.bool,
  onClickButton: PropTypes.func,
  hasInstructorLinkedCourse: PropTypes.bool,
};

export default StatusIndicator;
